/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

///////////////////////////
// Dashboard permissions //
//////////////////////////////////
// Available Widget Permissions //
//////////////////////////////////

// done
export const assetAssignment: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetQuality: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetStatus: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetsByLocation: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetsByProject: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetsByTypeBar: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetsByUser: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const contracts: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const costCenters: RoleList = [
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const projectFinance: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const projects: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const tradingAccounts: RoleList = [
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// to be done
export const assetsByModel: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const calibrations: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// done
export const assetsByUserType: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];
